import React from 'react'
import { isLocalView } from '../../Utils/Profile'
import StoreProfileMain from '../profiling/StoreProfileMain'
import Home from './Home'

const HomeRouter = () => {
    if (!isLocalView()) {
        return <StoreProfileMain />
    }
    return <Home />
}
export default HomeRouter
